import { supabase } from '../supabase';
import type { InteractionMessage } from '../../types/interactions';

export async function fetchUserInteractions(
  userId: string,
  limit: number = 50,
  offset: number = 0
): Promise<{ data: InteractionMessage[] | null; error: any }> {
  try {
    const { data, error } = await supabase
      .from('message_history')
      .select('*')
      .eq('user_id', userId)
      .order('sent_at', { ascending: false })
      .range(offset, offset + limit - 1);

    return { data, error };
  } catch (error) {
    return { data: null, error };
  }
}

export async function fetchInteractionById(
  messageId: string
): Promise<{ data: InteractionMessage | null; error: any }> {
  try {
    const { data, error } = await supabase
      .from('message_history')
      .select('*')
      .eq('id', messageId)
      .single();

    return { data, error };
  } catch (error) {
    return { data: null, error };
  }
}

export async function incrementShareCount(
  messageId: string
): Promise<{ error: any }> {
  try {
    const { error } = await supabase.rpc('increment_share_count', {
      message_id: messageId
    });

    return { error };
  } catch (error) {
    return { error };
  }
}

export async function recordSocialShare(
  userId: string,
  messageId: string,
  platform: string
): Promise<{ error: any }> {
  try {
    const { error } = await supabase
      .from('social_shares')
      .insert({
        user_id: userId,
        message_id: messageId,
        platform
      });

    return { error };
  } catch (error) {
    return { error };
  }
}

// Create the increment_share_count function if it doesn't exist
export async function createIncrementFunction(): Promise<{ error: any }> {
  try {
    const { error } = await supabase.rpc('exec_sql', {
      sql: `
        CREATE OR REPLACE FUNCTION increment_share_count(message_id uuid)
        RETURNS void AS $$
        BEGIN
          UPDATE message_history 
          SET share_count = COALESCE(share_count, 0) + 1 
          WHERE id = message_id;
        END;
        $$ LANGUAGE plpgsql;
      `
    });

    return { error };
  } catch (error) {
    return { error };
  }
}